
/**
 * Facilitates autofilling input fields
 *
 * @module 'modules/date-picker'
 */

import delegateListener from './delegate-listener';
import { triggerEvent } from '../modules/dom-helpers';

class Autofill {
  /**
   * Constructs a new Autofill instance
   *
   * @param {Object} [options] -
   * @param {String} [options.inputSelector] - Selector for the inputs that get autofilled
   * @param {String} [options.autofillCode] - The key code upon which autofilling is triggered
   * @param {Function} [options.fillFunction] - The autofilling function. When triggerChange is set, the change event is triggered on the element returned by this function.
   * @param {Boolean} [options.triggerChange] - If truthy, a 'change' event is triggered after autofilling.
   */
  constructor(options = {}) {
    const defaults = {
      inputSelector: 'input.autofill',
      autofillCode: 'Space',
      fillFunction: (event) => event.delegateTarget,
      triggerChange: true
    };
    Object.assign(this, defaults, options);
  }

  /**
   * Initializes the Autofill instance by attaching event handlers
   */
  init() {
    document.body.addEventListener(
      'keydown',
      delegateListener(this.inputSelector, this.handleInputKeydown.bind(this))
    );
  }

  /**
   * Triggers the fill function, if key code matches.
   *
   * @param {Event} event - The 'keydown' event object
   */
  handleInputKeydown(event) {
    if(event.code !== this.autofillCode) { return; }
    if(typeof this.fillFunction === 'function') {
      event.preventDefault();
      const target = this.fillFunction(event);

      if(target && this.triggerChange) {
        triggerEvent(target, 'change');
      }
    }
  }
}

module.exports = Autofill;
